import { Component } from '@angular/core';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-redirect-to-payment',
  templateUrl: './redirect-to-payment.component.html',
  styleUrl: './redirect-to-payment.component.scss',
  imports: [NgIcon, I18nPipe],
})
export class RedirectToPaymentComponent {}
